<template>
  <div>
    <Header/>
    <section class="main">
      <div class="container">
        <div class="token-table">
          <div class="token-table__header token">
            <div class="token__name-block">
              Token name
            </div>
            <div class="token__total-supply">
              Total token supply
            </div>
            <div class="token__transaction-vlm">
              Transaction volume
            </div>
            <div class="token__price" style="height: 20px;">
              € Price
            </div>
            <div class="token__num-transaction">
              Number of transaction
            </div>
            <div class="token__graphic">
              Supply
            </div>
          </div>
          <div class="token-table__item token" v-for="table in tableData">
            <div class="token__name-block">
              <div class="token__name-block-name">
                Token name
              </div>
              <div class="token__name-block-value">
                <div class="token__mark mark">
                  <span class="mark__currency" v-html="get_currency(table.mosaicName)"></span>
                </div>
                <div class="token__name">
                  <router-link :to="'/transactions/' + table.mosaicName + '/tx/1'">{{table.mosaicName}}</router-link>
                </div>
                <div class="token__desc">{{table.description}}
                </div>
              </div>
            </div>
            <div class="token__total-supply">
              <div class="token__total-supply-name">
                Total token supply
              </div>
              <div class="token__total-supply-value">
                {{table.initialSupply}}
              </div>
            </div>
            <div class="token__transaction-vlm">
              <div class="token__transaction-vlm-name">
                Transaction volume
              </div>
              <div class="token__transaction-vlm-value">
                {{table.volume}}
              </div>
            </div>
            <div class="token__price">
              <div class="token__price-name">
                € Price
              </div>
              <div class="token__price-value">
                {{table.price}}
                <ion-icon v-if="table.change === 'up'" name="arrow-round-up" class="arrow green"></ion-icon>
                <ion-icon v-else name="arrow-round-down" class="arrow red"></ion-icon>
              </div>
            </div>
            <div class="token__num-transaction">
              <div class="token__transaction-vlm-name">
                Number of transaction
              </div>
              <div class="token__transaction-vlm-value">
                {{table.txCount}}
              </div>
            </div>
            <div class="token__graphic">
              <div class="token__transaction-vlm-name">
                Supply
              </div>
              <div class="token__transaction-vlm-value">
                <MinChartContainer :totalSupply="table.initialSupply" :name="table.mosaicName"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
  import Header from '../components/Header';
  import MosaicProxy from '../../proxies/MosaicProxy';
  import { createNamespacedHelpers } from 'vuex';
  import entries from 'object.entries';
  import TxProxy from '../../proxies/TxProxy';
  import { divisibility } from '../../utils/Math_util';
  import MinChartContainer from './components/MinChartContainer';
  import Footer from '../components/Footer';
  import Chart from './components/Chart';
  import { get_currency } from '../../utils/currency';

  const { mapState, mapActions } = createNamespacedHelpers('core');

  export default {
    name: 'Index',
    components: {
      Chart,
      Footer,
      MinChartContainer,
      Header
    },
    async mounted() {
      const mosaics_proxy = new MosaicProxy();
      const response = await mosaics_proxy.get_mosaics();
      const response_tx = new TxProxy();

      this.tableData = response.map(resp => {
        const currency = this.getCurrency(resp.mosaicName);
        console.log("CURRENCY", currency);
        return {
          ...resp,
          txCount: null,
          volume: null,
          price: currency.price,
          change: currency.change
        };
      });
      this.loader = false;
      this.tableData.map(async (val, key) => {
        this.tableData[key].txCount = await mosaics_proxy.mosaic_tx_count(val.mosaicName);
        this.tableData[key].volume = divisibility(await response_tx.get_volume(val.mosaicName), val.divisibility) * val.price;
      });
    },
    computed: {
      ...mapState(['currency', 'currency_changes']),
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
      getCurrency(mosaicName) {
        const currency_ent = entries(this.currency);
        for (let currency of currency_ent) {
          if (mosaicName.indexOf(currency[0].toLowerCase()) !== -1) {
            return {
              price: currency[1],
              change: this.getChanges(currency[0])
            };
          }
        }
        return {
          price: 1,
          change: 'up'
        };
      },
      getChanges(currency) {
        console.log(currency, '<MMMM ')
        return this.currency_changes[currency]
      }
    },
    data: function () {
      return {
        tableData: [],
        loader: true,
        test_token: true,
        get_currency
      };
    }
  };
</script>
